export enum AddPaymentMethodQueries {
  WITH_PAYMENT = 'withPayment',
  TARIFF = 'tariff'
}
